import type { RootState } from '@core/Store'

export const selectIsClientVisible = (state: RootState) => state.kambi.isClientVisible
export const selectIsLoggedIn = (state: RootState) => state.kambi.isLoggedIn
export const selectIsBetslipMaximized = (state: RootState) => state.kambi.isBetslipMaximized
export const selectLogoutToken = (state: RootState) => state.kambi.logoutToken
export const selectLoginPending = (state: RootState) => state.kambi.isLoginPending
export const selectIsKambiRendered = (state: RootState) => state.kambi.isKambiRendered
export const selectPlayerSessionId = (state: RootState) => state.kambi.playerSessionId
export const selectIsBrowserSupported = (state: RootState) => state.kambi.isBrowserSupported
export const selectOutcomeIdsInBetslip = (state: RootState) => state.kambi.outcomeIdsInBetslip
export const selectActiveKambiJurisdiction = (state: RootState) => state.kambi.activeJurisdiction
